export * from './status-cabecalho-conferencia-de-fatura.pipe';
